import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '~core/models/customer-supplier.model';

@Pipe({
  name: 'currency',
  pure: true,
  standalone: true
})
export class CurrencyPipe implements PipeTransform {
  private readonly _currencyMap: Record<Currency, string> = {
    [Currency.xof]: 'XOF (CFA)',
    [Currency.usd]: 'USD ($)',
    [Currency.eur]: 'EURO (€)'
  };

  transform(currency: Currency | string | undefined): string {
    return this._currencyMap[currency as Currency] || currency || '';
  }
}
